






















































































import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import ElMenuItems from '../el-menu-items';
import ElMenuItemsCollapse from '../el-menu-items-collapse';
import { UserModule } from '@/store/modules/user';
import HistoryPage from '@/base/history-page';
import { ergodicTree } from '@/util/arrayToTree';
import { changeColor } from '@/util/changeColorType';
import Information from '@/views/basicFunctions/information/information.vue';
import PersonalCenter from '@/views/basicFunctions/personalCenter/personalCenter.vue';
import router from '@/router';
import { infoServer } from '@/api/installServer';

@Component({
  components: {
    ElMenuItems,
    ElMenuItemsCollapse,
    HistoryPage,
    Information,
    PersonalCenter,
  },
})
export default class Main extends Vue {
  private el: any;
  private nowActiveMenu: any = [];
  private shadowShowMark = true;
  private nowActiveMenuName = '';
  private changeMenuTypeMark = false;
  private changeColor = '0';
  private personalCenterMark = false;
  userName: any = '';
  userDeptId: any = '';
  infoObj: any = {};

  get loadingMark() {
    return this.$store.state.user.pageLoading;
  }
  get menuTree() {
    return this.$store.state.user.menuTree;
  }

  get menuList() {
    return this.$store.state.user.menuList;
  }

  get userInfo() {
    return this.$store.state.user.userInfo;
  }

  private async created() {
    this.getSystemInfo();
    await UserModule.getInfo(); // 获取菜单树
    await this.setCustomFlow();
    await this.nowMenu();
    this.changeBoxShadowTop(this.nowActiveMenu);

    // 获取主题标记缓存并切换到对应主题
    const colorType = localStorage.getItem('colorType');
    if (colorType) {
      changeColor(colorType);
      this.changeColor = colorType;
    }
  }

  getSystemInfo() {
    infoServer
      .getInfo()
      .then((res: any) => {
        this.infoObj = res.data;
        if (window.localStorage.getItem('infoTime') === this.infoObj.time) {
        } else {
          this.$notify.info({
            title: this.infoObj.summary,
            position: 'bottom-right',
            duration: 0,
            dangerouslyUseHTMLString: true,
            message: '<div>' + this.infoObj.content + '</div>' + '<div><a target="_Blank" href="' + this.infoObj.link + '">' + this.infoObj.link + '</a></div>',
            onClose: () => {
              window.localStorage.setItem('infoTime', this.infoObj.time);
            },
          });
        }
      })
      .catch((error: any) => {});
  }

  setCustomFlow() {
    const menuList = this.menuList.filter((item: any) => {
      return item.flowFormId;
    });
    const routerList: any = [];
    menuList.forEach((item: any) => {
      routerList.push({
        path: item.url,
        name: item.url,
        meta: {
          title: item.name,
        },
        component: () => import(/* webpackChunkName: "role" */ '@/views/professionalWork/workflow/flowWorkCustom/flowWorkCustom.vue'),
      });
    });
    this.$router.addRoutes([
      {
        path: '/flowWorkCustom',
        redirect: '/flowWorkCustom',
        name: 'flowWorkCustom',
        meta: {
          title: '自定义流程',
        },
        component: Main,
        children: routerList,
      },
    ]);
  }

  infoFunction() {
    const refStr = 'informationRef';
    const ref: any = this.$refs[refStr];
    ref.showDrawer();
  }
  goEnterDataViewPage() {
    this.$router.push('/dataView/ziYangDataViewBlack');
  }

  /**
   * @todo 暂放
   * @desc 主题切换
   */
  private changeColorType() {
    const colorType: any = localStorage.getItem('colorType');
    if (colorType === '1') {
      changeColor('0');
      this.changeColor = '0';
    } else {
      changeColor('1');
      this.changeColor = '1';
    }
    // if(this.showCover) {
    //   return false;
    // }
    // this.showCover = true;
    // setTimeout(()=>{
    //   const colorType: any = localStorage.getItem('colorType');
    //   if (colorType === '1') {
    //     changeColor('0');
    //     this.changeColor = '0';
    //   } else {
    //     changeColor('1');
    //     this.changeColor = '1';
    //   }
    //   setTimeout(()=>{
    //     this.showCover = false;
    //   },500)
    // },500)
  }

  /**
   * @desc 菜单收起、展开
   */
  private changeMenuType() {
    this.changeMenuTypeMark = !this.changeMenuTypeMark;
    if (this.changeMenuTypeMark) {
      this.el.style.transition = 'none';
      this.el.style.opacity = 0;
      this.shadowShowMark = false;
    } else {
      setTimeout(() => {
        this.el.style.transition = 'all .3s ease-in-out';
        this.el.style.opacity = 1;
        // this.shadowShowMark = true;
        if (this.$route.path === '/index' || this.$route.path === '/dataView/waterDataView' || this.$route.path === '/dataView/housedDataView') {
          this.el.style.transition = 'none';
          this.el.style.opacity = 0;
          this.shadowShowMark = false;
        } else {
          this.shadowShowMark = true;
        }
      }, 300);
    }
  }

  private mounted() {
    this.userName = window.localStorage.getItem('name');
    this.el = document.getElementById('menu-shadow');
    const userInfoData: any = window.localStorage.getItem('userInfo');
    this.userDeptId = JSON.parse(userInfoData).topDeptId;
  }

  handleMenuSelect(index: string, indexPath: string) {
    // 开始页面加载动画 各页面初始数据请求完成后调用方法停止动画 todo 页面切换时断开页面未完成请求
    // this.$store.commit('changePageLoading',true);
    if (this.$route.path !== index) {
      this.$router.push(index);
    }
  }

  /**
   * @desc 菜单滑动距离计算
   * @indexArr 菜单索引数组 - [目录, 一级索引, 二级索引]
   */
  changeBoxShadowTop(indexArr: any[]) {
    // console.log(this.menuTree);
    // console.log(indexArr);
    let topFirst = 0;
    for (let i = 0; i < indexArr[0]; i++) {
      topFirst += this.menuTree[i].children.length;
    }
    // console.log(topFirst);
    const top = (indexArr[1] + 1 + topFirst) * 56 + indexArr[2] * 50;
    this.el && (this.el.style.marginTop = top + 'px');
  }

  /**
   * @desc 获取当前菜单索引
   */
  nowMenu() {
    if (this.$route.path === '/index' || this.$route.path === '/dataView/waterDataView' || this.$route.path === '/dataView/housedDataView') {
      if (this.el) {
        this.el.style.transition = 'none';
        this.el.style.opacity = 0;
      }
      this.shadowShowMark = false;
    } else {
      // console.log(this.menuTree);
      const beforeIndexFirst = this.nowActiveMenu[0];
      const beforeIndex = this.nowActiveMenu[1];
      ergodicTree(this.menuTree, (item: any) => {
        if (item.url === this.$route.path) {
          // console.log(item);
          this.nowActiveMenu = item._index;
          this.nowActiveMenuName = item.name;
          if ((this.nowActiveMenu[1] !== beforeIndex || this.nowActiveMenu[0] !== beforeIndexFirst) && !this.changeMenuTypeMark) {
            setTimeout(() => {
              this.el && (this.el.style.transition = 'all .3s ease-in-out');
              this.el && (this.el.style.opacity = 1);
            }, 10);

            this.shadowShowMark = true;
          }
        }
      });
    }
  }

  /**
   * @desc 一级菜单展开监听 控制滑动阴影显示隐藏
   */
  handleMenuOpen(index: string, indexPath: string) {
    // console.log(this.nowActiveMenu);
    // console.log(this.menuTree);
    // console.log(this.menuTree[this.nowActiveMenu[0]].children[this.nowActiveMenu[1]].url);
    // console.log(index);
    if (this.menuTree[this.nowActiveMenu[0]] && this.menuTree[this.nowActiveMenu[0]].children[this.nowActiveMenu[1]]) {
      if (index === this.menuTree[this.nowActiveMenu[0]].children[this.nowActiveMenu[1]].url) {
        this.el.style.transition = 'all .3s ease-in-out';
        this.el.style.opacity = 1;
        this.shadowShowMark = true;
      } else {
        this.el.style.transition = 'none';
        this.el.style.opacity = 0;
        this.shadowShowMark = false;
      }
    }
  }

  /**
   * @desc 一级菜单关闭监听 控制滑动阴影隐藏
   */
  handleMenuClose(index: string, indexPath: string) {
    // console.log(indexPath);
    if (index === this.menuTree[this.nowActiveMenu[0]].children[this.nowActiveMenu[1]].url) {
      this.el.style.transition = 'none';
      this.el.style.opacity = 0;
      this.shadowShowMark = false;
    }
  }

  handleCommand(command: any) {
    // console.log(command);
    switch (command) {
      case 'logOut':
        window.localStorage.setItem('token', '');
        this.$router.push('/login');
        break;
      case 'personalCenter':
        this.personalCenterMark = true;
        break;
    }
  }

  private back() {
    this.personalCenterMark = false;
  }

  // 监听路由变化 获取菜单索引并移动阴影
  @Watch('$route')
  private async changeNowMenu() {
    this.personalCenterMark = false;
    await this.nowMenu();
    await this.changeBoxShadowTop(this.nowActiveMenu);
  }
}
